import { Model } from '../../shared/models/model';

export class LoginVerification extends Model {
    public challenge: string;
    public skip: false;
    public client: { id: string, name: string, logo: string };
    public sessionId: string;
    public redirectTo: string;
}
